import { render, staticRenderFns } from "./functionalNav.vue?vue&type=template&id=05b0688b&scoped=true"
import script from "./functionalNav.vue?vue&type=script&lang=js"
export * from "./functionalNav.vue?vue&type=script&lang=js"
import style0 from "./functionalNav.vue?vue&type=style&index=0&id=05b0688b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0688b",
  null
  
)

export default component.exports